<template>
  <div class="switch-page-container">
    <div v-for="(page, index) in selectedPages" :key="index">
      <BbBtn
        size="small"
        type="secondary"
        :class="{ selected: index === selectedPage }"
        @click="selectPage(page, index)"
      >
        <BbIcon :name="page.icon" size="medium" type="outlined" />
        <TextBody :text="page.title" :body-type="2" tag="span" weight="medium" />
      </BbBtn>
    </div>
  </div>
</template>

<script>
import { watch, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router/dist/vue-router';

import { Routes } from '~/constants/routes';

import useConversations from '~/composables/useConversations';
import useAuthoring from '~/composables/useAuthoring';
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  setup() {
    const router = useRouter();
    const { t } = useI18n();

    const { isAuthoringPage } = useAuthoring();
    const { setDefaultState } = useConversations();

    const selectedPage = ref(isAuthoringPage.value ? 1 : 0);

    const selectedPages = [
      { title: t('assist.discover'), icon: 'compass' },
      {
        title: t('author.author'),
        icon: 'pencildraw',
      },
    ];

    const selectPage = (page, index) => {
      selectedPage.value = index;
    };

    onMounted(() => {
      if (isAuthoringPage.value) {
        selectedPage.value = 1;
      } else {
        selectedPage.value = 0;
      }
    });

    watch(
      () => selectedPage.value,
      () => {
        setDefaultState();
        if (selectedPage.value === 1) {
          router.push({ name: Routes.Authoring.name });
        } else if (selectedPage.value === 0) {
          router.push({ name: Routes.Conversation.name });
        }
      },
    );

    return {
      selectedPages,
      selectedPage,
      selectPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.switch-page-container {
  height: 48px;
  padding: $bb-spacing-2;
  background-color: $bb-neutral-6 !important;
  border-radius: 100px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $bb-spacing-2;

  :deep(.bb-btn.secondary) {
    background-color: $bb-neutral-0;
    border: unset;

    .v-btn__content {
      display: flex;
      align-items: center;
      gap: $bb-spacing-2;
    }

    .v-btn__content > * {
      color: $bb-primary-3 !important;
      gap: $bb-spacing-2;
    }
  }

  :deep(.bb-btn.secondary.selected) {
    background-color: $bb-neutral-1 !important;

    .v-btn__content > * {
      color: $bb-neutral-0 !important;
    }

    span {
      font-weight: 700 !important;
    }
  }
}
</style>
